import { IdentityStatusChange } from '../enums/identity-status-change.enum';

export const IDENTITY_STATUS_UPDATE_MEDIA_TYPE = 'application/vnd.io.idaas.admin.api.identity.status.update.v1+json';

export class IdentityStatusUpdate {
  public id: string;
  public identifier: string;
  public status: IdentityStatusChange;

  toBackendPatch() {
    return {
      id: this.id,
      identifier: this.identifier,
      status: this.status,
    };
  }
}
